module.exports = __webpack_public_path__ + "static/img/生产_bottom.8c82b249.png";